// extracted by mini-css-extract-plugin
module.exports = {"sponsoredBanner":"Gh","sponsoredTooltipWrapper":"Hh","sponsoredTooltip":"Ih","newCard":"Jh"};